import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'No deposits found for your address',
  description:
    'We could not detect a deposit from your address. Make sure you’re in the correct market or make a first time deposit',
  orDepositNow: 'Or deposit your assets now',
  depositNow: 'Deposit now',
});
